import StoreClosedModal from 'components/StoreClosedModal';
import moment from 'moment-timezone';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Header from '../../components/Header';
import getFormattedMobileNumber from '../../helpers/getFormattedMobileNumber';
import '../../assets/css/bootstrap.min.css';
import '../../assets/css/swiper.min.css';
import '../../assets/css/style.css';
import '../../assets/css/icon.css';
import '../../assets/css/icon-new.css';
import '../../assets/css/responsive.css';
import '../../index.css'; // add tailwind
import { init, recordPhoneClick } from './actions';
import { selectStoreConfig } from './selectors';
import NotificationModal from 'components/NotificationModal';

export default function Layout({
  showHalfItem,
  halfItem,
  signOut,
  goHome,
  hOrder,
  reservation,
  closeLoyalty,
  loyalty,
  updateOrderStage,
  addReservationhandler,
  history,

  children,
  
  // review,
  // updateCurrentUser,
  // openDelivery,
}) {
  const appContainerRef = useRef(null);
  const {
    currentOrder,
    userDetails,
    // ui: { slideIndex },
    // specialFilter: {
    //   isSpecialFilterApplied,
    //   spMenuItems,
    //   spMenuSizes,
    //   spSubModifiers,
    //   // spMenuCategories,
    // },
  } = useSelector((state) => state.homeReducer);
  const storeConfig = useSelector(selectStoreConfig);
  const dispatch = useDispatch();

  const handleTouch = (e) => {
    const {
      changedTouches: [{ pageX }],
    } = e;
    if (pageX < 10 || pageX > window.innerWidth - 10) e.preventDefault();
  };

  useEffect(() => {
    if (!storeConfig) return;
    dispatch(init(storeConfig));

  },[storeConfig, dispatch])

  useEffect(() => {
    const containerRef = appContainerRef.current;
    containerRef?.addEventListener('touchstart', handleTouch);

    return () => {
      containerRef?.removeEventListener('touchstart', handleTouch);
    };
  }, []);

  const recordPhoneClickHandler = () => {
    let obj = {
      date: moment().tz(storeConfig.timeZone).format('YYYY-MM-DD HH:mm'),
    };
    if (
      userDetails &&
      userDetails.firstName &&
      userDetails.lastName &&
      userDetails.mobileNumber
    ) {
      obj.firstName = userDetails.firstName;
      obj.lastName = userDetails.lastName;
      obj.mobileNumber = getFormattedMobileNumber(userDetails.mobileNumber);
    }
    obj.storeId = storeConfig.storeId;
    obj.restaurantId = storeConfig.restaurantId;
    dispatch(recordPhoneClick(obj));
  };

  return (
    <div ref={appContainerRef}>
      <StoreClosedModal
        storeId={storeConfig.storeId}
        timeZone={storeConfig.timeZone}
      />
      <NotificationModal />
      <Header
        showHalfItem={showHalfItem}
        halfItem={halfItem}
        signOut={signOut}
        currentOrder={currentOrder}
        goHome={goHome}
        addReservationhandler={addReservationhandler}

        history={history}
        hOrder={hOrder}
        reservation={reservation}
        closeLoyalty={closeLoyalty}
        loyalty={loyalty}
        recordPhoneClickHandler={recordPhoneClickHandler}
        updateOrderStage={updateOrderStage}

        // closeAbout={closeAbout} // 🪢 Not being passed as prop
        // closeReview={closeReview} // 🪢 Not being passed as prop

        // review={review} // ⛔️ Not Needed
        // spMenuCategories={spMenuCategories} // ⛔️ Not Needed
        // slideIndex={slideIndex} // ⛔️ Not Needed
        // about={about} // ⛔️ Not Needed
        // closeReservation={closeReservation} // ⛔️ Not Needed
        // updateCurrentUser={updateCurrentUser} // ⛔️ Not Needed
        // openDelivery={openDelivery} // ⛔️ Not Needed
      />
      {children}
    </div>
  );
}